module.exports = __webpack_public_path__ + "img/test1.dd88855d.jpg";